module.exports = __webpack_public_path__ + "static/avengers-7bfc486365921aec040337b67193ae55.jpg";